import { render } from "./px-information-card-collapsible.vue?vue&type=template&id=00aa316e&scoped=true&ts=true"
import script from "./px-information-card-collapsible.vue?vue&type=script&lang=ts"
export * from "./px-information-card-collapsible.vue?vue&type=script&lang=ts"

import "./px-information-card-collapsible.vue?vue&type=style&index=0&id=00aa316e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00aa316e"]])

export default __exports__